import api from '../../plugins/api';

// Загрузка фото авто для оценки залога Freedom (комиссионное/б/у авто).
// documentType: FRONT_SIDE_IMAGE | LEFT_SIDE_IMAGE | RIGHT_SIDE_IMAGE |
//               BACK_SIDE_IMAGE | VIN_IMAGE | TECHNICAL_PASSPORT_FRONT_SIDE_IMAGE
// Бэкенд складывает файл в completed_order_documents под нужным typeId/serialNumberId,
// а при выборе Freedom отправляет фото в банк методом /upload перед /confirm.
const ffinUploadCarPhoto = ({ appealId, documentType, file, onProgress }) => {
  const formData = new FormData();
  formData.append('appealId', appealId);
  formData.append('documentType', documentType);
  formData.append('file', file);

  return api.post('/api/bank/ffin/car-photo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: onProgress
      ? (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
          onProgress({ loaded: progressEvent.loaded, total: progressEvent.total, percent });
        }
      : undefined,
  });
};

export default ffinUploadCarPhoto;
